import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcp-text',
  template: `<div [innerHTML]="data | sanitizeHtml"></div>`,
  styleUrls: []
})
export class TextComponent {
  @Input() data: any;

}
